











































































import Vue from 'vue';
import type { Swiper } from 'swiper';
import { tools } from '../constants';
import type { Tool } from '../types';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

type Data = {
  tools: Tool[];
  swiperInstance?: Swiper;
};

export default Vue.extend({
  name: 'MainPageTools',
  components: {
    BravadoButtonV3,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      tools,
      swiperInstance: undefined,
    };
  },
  mounted() {
    import('swiper').then(({ Swiper, Pagination, Grid }) => {
      Swiper.use([Pagination, Grid]);
      this.swiperInstance = new Swiper('.landing-features', {
        slidesPerView: 'auto',
        grid: {
          rows: 1,
          fill: 'row',
        },
        pagination: {
          el: '.landing-features__pagination',
          clickable: true,
        },
      });
    });
  },
  beforeDestroy() {
    try {
      this.swiperInstance?.destroy();
    } catch (e) {}
  },
  methods: {
    onToolButtonClick(path: string) {
      this.$analytics.logEvent(path);
    },
  },
});
